(() => {
  const facts = document.querySelector('[data-product-facts]');
  const variantsNode = document.querySelector('[data-product-variants]');
  if (!facts || !variantsNode) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsNode.textContent || '[]');
  } catch (_) {
    return;
  }
  if (!variants.length) return;

  const records = window.ROAMUNO_PLAN_DATA?.bySku || {};
  const planLabels = window.ROAMUNO_PLAN_LABELS;
  const isLaunchAllowed = window.ROAMUNO_LAUNCH_ELIGIBILITY?.isAllowedVariantId || (() => true);
  const currency = document.querySelector('variant-selects')?.dataset.currencyCode || 'USD';
  const language = document.documentElement.lang || 'en';
  const money = new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
  });

  const priceValue = (variant) => {
    const raw = Number(variant?.price);
    if (!Number.isFinite(raw)) return null;
    return raw / 100;
  };

  const available = variants
    .filter((variant) => variant.available !== false && isLaunchAllowed(variant.id))
    .map((variant) => {
      const record = records[String(variant.sku || '')] || {};
      const price = priceValue(variant);
      return { variant, record, price };
    });
  if (!available.length) return;

  const selectedVariant = () => {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
    const selectedId = String(idInput?.value || '');
    return available.find((item) => String(item.variant.id) === selectedId) || null;
  };

  const updateSticky = (item) => {
    const sticky = document.querySelector('[data-mobile-sticky-atc]');
    if (!sticky || !item) return;
    const title = sticky.querySelector('[data-sticky-title]');
    const price = sticky.querySelector('[data-sticky-price]');
    const submit = sticky.querySelector('[data-sticky-submit]');
    if (title) title.textContent = planLabels?.formatPlan(item.record) || '';
    if (price && item.price != null) price.textContent = `${money.format(item.price)} ${currency}`;
    const reference = sticky.querySelector('[data-reference-cents]');
    if (reference && item.price != null) reference.dataset.referenceCents = String(item.variant.price);
    if (submit) submit.disabled = item.variant.available === false;
  };

  const update = () => {
    const item = selectedVariant();
    if (!item) return;
    planLabels?.localize(document);
    updateSticky(item);
  };

  document.querySelector('product-info')?.addEventListener('change', update);
  document.querySelector('product-info')?.addEventListener('variant:change', update);
  update();

  const sticky = document.querySelector('[data-mobile-sticky-atc]');
  const primarySubmit = document.querySelector('[data-type="add-to-cart-form"] button[name="add"]');
  if (sticky && primarySubmit && 'IntersectionObserver' in window) {
    const media = window.matchMedia('(max-width: 749px)');
    const syncVisibility = (visible) => {
      sticky.hidden = !media.matches || visible;
    };
    const observer = new IntersectionObserver(([entry]) => syncVisibility(entry.isIntersecting), { threshold: 0.15 });
    observer.observe(primarySubmit);
    media.addEventListener?.('change', () => syncVisibility(primarySubmit.getBoundingClientRect().top >= 0 && primarySubmit.getBoundingClientRect().bottom <= window.innerHeight));
  }
})();
